import { Plane, Car, Users, Map, Crown, ArrowLeftRight } from 'lucide-react';
import { Button } from './ui/button';
import { useLang } from '../contexts/LanguageContext';

export default function Services() {
  const { t } = useLang();

  const services = [
    { icon: Plane, title: t('svc_airport'), description: t('svc_airport_d'), color: 'cyan' },
    { icon: Car, title: t('svc_private'), description: t('svc_private_d'), color: 'orange' },
    { icon: Users, title: t('svc_group'), description: t('svc_group_d'), color: 'cyan' },
    { icon: Map, title: t('svc_excursion'), description: t('svc_excursion_d'), color: 'orange' },
    { icon: Crown, title: t('svc_vip'), description: t('svc_vip_d'), color: 'cyan' },
    { icon: ArrowLeftRight, title: t('svc_city'), description: t('svc_city_d'), color: 'orange' }
  ];

  const scrollToBooking = () => {
    document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" className="py-24 bg-[#0A192F]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-cyan-400 text-sm uppercase tracking-[0.2em] mb-4 font-semibold">{t('services_label')}</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white tracking-tight mb-6">
            {t('services_title_1')} <span className="gradient-text">{t('services_title_2')}</span>
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto">{t('services_desc')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div key={index} className="premium-card p-8 card-hover group" data-testid={`service-card-${index}`}>
              <div className={`w-14 h-14 rounded-xl flex items-center justify-center mb-6 ${
                service.color === 'cyan' ? 'bg-cyan-500/20 text-cyan-400' : 'bg-orange-500/20 text-orange-400'
              }`}>
                <service.icon className="w-7 h-7" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3 group-hover:text-cyan-400 transition-colors">{service.title}</h3>
              <p className="text-slate-400 mb-6 leading-relaxed">{service.description}</p>
              <Button variant="ghost" className="text-cyan-400 hover:text-cyan-300 hover:bg-cyan-400/10 p-0 h-auto font-semibold"
                onClick={scrollToBooking} data-testid={`service-learn-more-${index}`}>
                {t('learn_more')} →
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
